// TODO: add doc block to this function to explain vars. Ask me if you need clarification if doc block not here yet.
// Dynamic on change function intended to handle ALL on change cases. Need different variables for nested data, <Select> elements, and array values.
const handleOnChange = (props) => {
  const {
    changeFunction, e, preventDefault, boolean, parent,
    itemID, nestedProp, compareProp,
    isObject, objectProperty, validateNumeric,
    secondProp, secondPropDdlText, select, value, checkbox
  } = props;

  // Currently only handles properties two levels deep (don't currently have any deeper)
  if (preventDefault) {
    e.preventDefault();
  }

  let setVal;
  if (checkbox) {
    setVal = e.target.checked;
  } else if (!select) {
    setVal = e.target.value;
  } else {
    setVal = value;
  }


  if (boolean) {
    let boolVal
    boolVal = (setVal === "true" ? true : (setVal === 'false' ? false : ""))
    setVal = boolVal
  }

  // console.log('my value', setVal)
  let secondVal;
  if (secondPropDdlText) {
    const inIndex = e.nativeEvent.target.selectedIndex;
    const inName = e.nativeEvent.target[inIndex].text;
    secondVal = inName
  }

  // Return and don't update value if value entered in numeric input is invalid or percent < 0 or > 100
  if (validateNumeric && !(setVal).match(/^-?([0-9]{0,})?(\.)?([0-9]{0,2})?$/)) { return }

  if (!isObject) {
    changeFunction(setVal)
  }
  else {
    if (parent && nestedProp) {
      // Update a nested property

      changeFunction((prevState) => ({
        ...prevState,
        [parent]: {
          ...prevState[parent],
          [objectProperty]: setVal,
          ...secondProp && { [secondProp]: secondVal }
        },
      }));
    } else if (parent && itemID) {
      // Update value in nested array 
      changeFunction((prevState) => ({
        ...prevState,
        [parent]: prevState[parent].map((item) =>
          itemID === item[compareProp]
            ? { ...item, [objectProperty]: setVal }
            : item
        ),
      }));
    } else {
      // Update a top-level property
      // console.log('should be here', setVal)
      changeFunction((prevState) => ({
        ...prevState,
        [objectProperty]: setVal,
      }));
    }
  }
};

// Function to remove item from arbitrary useState array (nested inside object or not); option to return new array instead of setting
const removeItemFromArray = (props) => {
  const {
    updateFunction, indexToRemove, compareProp,
    isInsideObject, objectProperty, object,
    plainArray, returnNewArray
  } = props;

  let updatedItems = []
  if (isInsideObject) {
    updatedItems = object[objectProperty].filter(item => item[compareProp] !== indexToRemove);
    if (!returnNewArray) {
      updateFunction(prevState => ({
        ...prevState, [objectProperty]: updatedItems
      }))
    }
  } else {
    updatedItems = plainArray.filter(item => item[compareProp] !== indexToRemove);
    if (!returnNewArray) {
      updateFunction(updatedItems)
    }
  }
  if (returnNewArray) { return updatedItems }
}

// Formats number for display with commas and 2 point decimal.
function formatNumDisplay(numAsString) {
  if (numAsString) {
    try {
      const number = parseFloat(numAsString)
      const formatted = number.toLocaleString("en-US", { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 })
      // console.log('NAS, Num, Formatted', numAsString, number, formatted)
      return formatted

    } catch (err) {
      console.error("Error in formatNumDisplay", err)
    }
  } else return ''
}

function partition(array, filter) {
  let pass = [], fail = [];
  array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
  return [pass, fail];
}

function formatDateDisplay(date) {
  if (date) {
    let split = date.split("T")
    return split[0]
  }
}

// Function to sort data
function sortAssets(assetsToSort) {
  const sortedFirst = assetsToSort.sort((a, b) => {
    if (a.ATPFirstName_VC < b.ATPFirstName_VC) {
      return -1;
    } else if (a.ATPFirstName_VC > b.ATPFirstName_VC) {
      return 1;
    } else {
      return 0
    }
  });
  const sorted = sortedFirst.sort((a, b) => {
    if (a.ATPLastName_VC < b.ATPLastName_VC) {
      return -1;
    } else if (a.ATPLastName_VC > b.ATPLastName_VC) {
      return 1;
    } else {
      return 0
    }
  })
  return sorted
}

// Helper function for handleSearchKeyUp
let s = [];
function getNestedStrings(obj, level) {
  if (obj) {
    if (level === 1) { s = [] }  // at parent level, start with an empty array
    const valArr = Object.values(obj);  // get array of object property values
    const strArr = valArr.filter((o) => { return (typeof o === 'string') });  // filter array for strings
    const objArr = valArr.filter((o) => { return (typeof o === 'object') });  // filter array for objects
    if (strArr.length > 0) { s = [...s, ...strArr]; };  // append strings to result array
    objArr.forEach((x) => { getNestedStrings(x, level + 1) });  // recurse through objects collecting child strings
    if (level === 1) { return s; };  // at parent level, return the string array
  }
};

const handleSearchKeyUp = ({ searchString, filters, assets, filterCombine, setFilteredAssets }) => {
  // console.log('my filters', filters)
  if (searchString.length && !filters?.division?.length && !filters?.assignment && !filters?.purchaseStatus?.length && !filters?.activeStatus?.length && !filters?.assetType?.length) {
    const res = (assets.filter((x) => {  // filter resources for object(s) with strings that include searchStr
      return (getNestedStrings(x, 1).some((y) => {
        return (y.toLowerCase().includes(searchString.toLowerCase()))
      }))
    }));
    setFilteredAssets(res)  // show result object(s)
  }
  else if (searchString.length && (filters?.division != null || filters?.assignment != null || filters?.purchaseStatus != null || filters?.activeStatus != null || filters?.assetType != null)) {
    const res = (filterCombine.filter((x) => {  // filter resources for object(s) with strings that include searchStr
      return (getNestedStrings(x, 1).some((y) => {
        return (y.toLowerCase().includes(searchString.toLowerCase()))
      }))
    }));
    setFilteredAssets(res)  // show result object(s)
  }
  else if (!searchString?.length && (filters?.division != null || filters?.assignment != null || filters?.purchaseStatus != null || filters?.activeStatus != null || filters?.assetType != null)) {
    setFilteredAssets(filterCombine)
  }
  else {
    setFilteredAssets(assets)
  }
}

const handleReapplySearchString = ({ filters, assets, setFilteredAssets }) => {
  if (filters.searchString.length) {
    const res = (assets.filter((x) => {  // filter resources for object(s) with strings that include searchStr
      return (getNestedStrings(x, 1).some((y) => {
        return (y.toLowerCase().includes(filters.searchString.toLowerCase()))
      }))
    }));
    setFilteredAssets(res)  // show result object(s)
  }
}

const usStates = [
  { label: "AL", value: 1 },
  { label: "AK", value: 2 },
  { label: "AZ", value: 3 },
  { label: "AR", value: 4 },
  { label: "CA", value: 5 },
  { label: "CO", value: 6 },
  { label: "CT", value: 7 },
  { label: "DE", value: 8 },
  { label: "FL", value: 9 },
  { label: "GA", value: 10 },
  { label: "HI", value: 11 },
  { label: "ID", value: 12 },
  { label: "IL", value: 13 },
  { label: "IN", value: 14 },
  { label: "IA", value: 15 },
  { label: "KS", value: 16 },
  { label: "KY", value: 17 },
  { label: "LA", value: 18 },
  { label: "ME", value: 19 },
  { label: "MD", value: 20 },
  { label: "MA", value: 21 },
  { label: "MI", value: 22 },
  { label: "MN", value: 23 },
  { label: "MS", value: 24 },
  { label: "MO", value: 25 },
  { label: "MT", value: 26 },
  { label: "NE", value: 27 },
  { label: "NV", value: 28 },
  { label: "NH", value: 29 },
  { label: "NJ", value: 30 },
  { label: "NM", value: 31 },
  { label: "NY", value: 32 },
  { label: "NC", value: 33 },
  { label: "ND", value: 34 },
  { label: "OH", value: 35 },
  { label: "OK", value: 36 },
  { label: "OR", value: 37 },
  { label: "PA", value: 38 },
  { label: "RI", value: 39 },
  { label: "SC", value: 40 },
  { label: "SD", value: 41 },
  { label: "TN", value: 42 },
  { label: "TX", value: 43 },
  { label: "UT", value: 44 },
  { label: "VT", value: 45 },
  { label: "VA", value: 46 },
  { label: "WA", value: 47 },
  { label: "WV", value: 48 },
  { label: "WI", value: 49 },
  { label: "WY", value: 50 }
];

const FormUtilsFunctions = {
  handleOnChange,
  removeItemFromArray,
  formatNumDisplay,
  partition,
  formatDateDisplay,
  sortAssets,
  getNestedStrings,
  handleSearchKeyUp,
  handleReapplySearchString,
  usStates
}

export default FormUtilsFunctions;
